import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type CompanyDetailsId = Branded<string, "CompanyDetailsId">;
const companyDetailsIdPrefix = "company_details__";
const {
    factory: companyDetailsIdFactory,
    assert: isCompanyDetailId,
    zodSchema: companyDetailsIdZodSchema,
} = genericId<CompanyDetailsId>(companyDetailsIdPrefix);

export {
    companyDetailsIdFactory,
    companyDetailsIdZodSchema,
    isCompanyDetailId,
};
export type { CompanyDetailsId };
